import React from 'react';
import classNames from 'classnames';
import cls from './ProjectTeamPurchasersRow.module.css';
import { useProjectTeamPurchasersRow } from './useProjectTeamPurchasersRow';
import { PeopleCard } from '../../UI/PeopleCard/PeopleCard';
import { CardList } from '../../UI/CardList/CardList';
import { CardTitle } from '../../UI/CardTitle/CardTitle';
import { CardType, InviteCard } from '../../UI/InviteCard/InviteCard';
import { OpenedInviteCard } from '../../useProjectTeamInvite';
import { EmployersForSelect } from '../../../../../TemporaryConmonents/AddProject/SecondStep/useSecondStep';
import { Roles } from '../../../../../TemporaryConmonents/AddProject/types/types';
import { useTranslation } from 'react-i18next';

interface ProjectTeamPurchasersRowProps {
    classes?: string;
    openedInviteCard: OpenedInviteCard;
    onOpenedInviteCardChange: (value: OpenedInviteCard) => void;
    employersList: EmployersForSelect[];
    onEmployersListSet: (value: string) => void;
    closingCard: string;
    onSetClosingCard: (value: string) => void;
}

export const ProjectTeamPurchasersRow = ({
    classes,
    openedInviteCard,
    onOpenedInviteCardChange,
    onEmployersListSet,
    employersList,
    onSetClosingCard,
    closingCard,
}: ProjectTeamPurchasersRowProps) => {
    const { t } = useTranslation();
    const { purchases } = useProjectTeamPurchasersRow();
    return (
        <div className={classNames(cls.ProjectTeamPurchasersRow, [classes])}>
            <CardTitle
                title={t('ProjectTeam.ProjectTeamInvite.ProjectTeamPurchasersRow.CardTitle')}
                role={Roles.PURCHASER}
            />
            <CardList>
                <InviteCard
                    closingCard={closingCard}
                    onSetClosingCard={onSetClosingCard}
                    onEmployersListSet={onEmployersListSet}
                    employersList={employersList}
                    type={CardType.PURCHASER}
                    openedInviteCard={openedInviteCard}
                    onOpenedInviteCardChange={onOpenedInviteCardChange}
                />
                {purchases.ids.map((id) => (
                    <PeopleCard employerId={id} />
                ))}
            </CardList>
        </div>
    );
};
